/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  SettleLeverageAccruedInterestOptions,
  SettleLeverageAccruedInterestResponses,
} from '../types/SettleLeverageAccruedInterest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Settle current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/settle}
 */
export function settleLeverageAccruedInterest<ThrowOnError extends boolean = true>(
  options: Options<SettleLeverageAccruedInterestOptions, ThrowOnError>,
): Unwrappable<RequestResult<SettleLeverageAccruedInterestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/leverage/accrued_interest/settle',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<SettleLeverageAccruedInterestResponses, ThrowOnError>>,
  )
}
